<ng-container
  *ngIf="
    evidence?.evidenceType !== 'Credential' && evidence?.evidenceType !== 'ActiveCertification';
    else credentialOrCertification
  "
>
  <div *ngIf="attributeUiType === 'LongAnswer'; else isComplex" [innerHtml]="asString(value) | safeHtml"></div>
  <ng-template #isComplex>
    <complex-field-snapshot
      *ngIf="attributeUiType === 'Complex'; else isSkill"
      [subFields]="asComplexSubFields(value)"
      [showAllFields]="showAllFields"
    ></complex-field-snapshot>
  </ng-template>

  <ng-template #isSkill>
    <skill *ngIf="attributeUiType === 'Skill'; else isStar" [selectedSkillLevel]="asSkillOrStar(value)"></skill>
  </ng-template>

  <ng-template #isStar>
    <app-star-rating-attribute
      *ngIf="attributeUiType === 'StarRating'; else default"
      [selectedStarRating]="asSkillOrStar(value)"
    ></app-star-rating-attribute>
  </ng-template>

  <ng-template #default>{{ asString(value) | fieldDisplay: attributeUiType }}<ng-content></ng-content></ng-template>
</ng-container>

<ng-template #credentialOrCertification>
  <credential-snapshot
    *ngIf="evidence?.evidenceType === 'Credential'; else certification"
    [credential]="asCredential(value)"
    [credentialName]="evidence?.evidenceDescription"
  ></credential-snapshot>
</ng-template>
<ng-template #certification>
  <certification-snapshot [certification]="asCertification(value)"></certification-snapshot>
</ng-template>
